import React, { useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import DeleteModal from "components/DeleteModal/DeleteModal";
import { deleteTemplateAPI } from "Api/templateAPI";
import { consoleLog } from "helpers";

const EditOrDeleteTemplate = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    setMessageFormData,
    initialMessageFormState,
    setFetchMessage,
    setIsOpenMessageEditForm,
  } = useGlobalContext();

  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    const response = await deleteTemplateAPI(
      { id: props.cell.row.original.id },
      () => {},
      token
    );
    if (response) {
      toast.success(`Template deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchMessage(true);
    }
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    setMessageFormData(
      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
          }
        : {
            ...initialMessageFormState,
          }
    );
    setIsOpenMessageEditForm(true);
    consoleLog([props, "props"]);
  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleDeleteClick}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />
    </div>
  );
};

export default EditOrDeleteTemplate;
